import React from 'react';
import { Chip } from '@heroui/react';
import { Star, ArrowUp, Bug, Trash2 } from 'lucide-react';

const TYPE_CONFIG = {
	feature: { icon: Star, label: 'Feature', color: 'primary' },
	improvement: { icon: ArrowUp, label: 'Improvement', color: 'success' },
	fix: { icon: Bug, label: 'Fix', color: 'warning' },
	breaking: { icon: Trash2, label: 'Breaking', color: 'danger' }
};

function ChangelogItem({ item, isNew }) {
	const config = TYPE_CONFIG[item.type] ?? TYPE_CONFIG.feature;
	const Icon = config.icon;

	return (
		<div
			className={`flex gap-3 p-3 rounded-lg ${item.isHighlight ? 'bg-primary-50 border border-primary-200' : ''}`}
		>
			<div className={`flex-shrink-0 mt-0.5`}>
				<Icon className="w-4 h-4 text-default-500" />
			</div>
			<div className="flex-1 min-w-0">
				<div className="flex items-center gap-2 flex-wrap">
					<span className="font-medium text-sm text-default-900">{item.title}</span>
					<Chip size="sm" variant="flat" color={config.color} className="h-5 text-xs">
						{config.label}
					</Chip>
					{isNew && (
						<Chip size="sm" variant="solid" color="primary" className="h-5 text-xs">
							New
						</Chip>
					)}
				</div>
				{item.description && <p className="text-xs text-default-500 mt-1">{item.description}</p>}
			</div>
		</div>
	);
}

export default ChangelogItem;
